var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralRoomUnitEmptyState = function SvgDAhuGeneralRoomUnitEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 594,
    y: 64,
    width: 28,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621,65v26h-26v-26h26M622,64h-28v28h28v-28h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M605.51,89.74h-7.9c-.86,0-1.55-.69-1.55-1.55v-7.16c0-.93.75-1.68,1.68-1.68h7.63c.93,0,1.68.75,1.68,1.68v7.16c0,.86-.69,1.55-1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "604.39 85.47 601.56 81.75 598.73 85.47 600.55 85.47 600.55 87.34 602.57 87.34 602.57 85.47 604.39 85.47",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M618.39,89.74h-7.9c-.86,0-1.55-.69-1.55-1.55v-7.16c0-.93.75-1.68,1.68-1.68h7.63c.93,0,1.68.75,1.68,1.68v7.16c0,.86-.69,1.55-1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "617.27 83.62 614.44 87.34 611.61 83.62 613.43 83.62 613.43 81.75 615.45 81.75 615.45 83.62 617.27 83.62",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M617.19,74.21c0-.16-.13-.29-.29-.29s-.29.13-.29.29.13.29.29.29.29-.13.29-.29",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.45,74.7h1.67c.23,0,.46,0,.66-.05.02,0,.03,0,.05-.01l-.12-.67h-2.9l-.55.32c.1.14.24.26.41.33.23.09.51.09.78.09",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.2,70.38c-.08.12-.12.26-.12.41v2.54c0,.28,0,.55.09.78.01.03.03.06.04.09,0,.01.01.03.02.04l.58-.33v-3.17l-.61-.35Z",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.33,70.23l.49-.28h2.95l.49.28s.03.02.04.03c.03.05,0,.11-.04.13l-.49.28h-2.95l-.49-.28s-.03-.02-.04-.04c-.03-.05,0-.11.04-.13",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.5,67.73v2.1c0,.15-.04.29-.12.41l-.61-.35v-2.89l.21-.59c.19.11.34.28.43.48.1.25.1.54.1.84",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.93,66.39s-.01,0-.02,0c0,0-.01,0-.02-.01,0,0-.02,0-.03,0-.24-.1-.54-.1-.84-.1h-1.47c-.3,0-.59,0-.84.1-.14.06-.27.15-.37.26,0,.01-.02.03-.03.04l.59.34h2.8l.22-.61Z",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path162",
    d: "M612.75,74.7h1.67c.23,0,.46,0,.66-.05.02,0,.03,0,.05-.01l-.12-.67h-2.9l-.55.32c.1.14.24.26.41.33.23.09.51.09.78.09",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path166",
    d: "M611.5,70.38c-.08.12-.12.26-.12.41v2.54c0,.28,0,.55.09.78.01.03.03.06.04.09,0,.01.01.03.02.04l.58-.33v-3.17l-.61-.35Z",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path168",
    d: "M611.62,70.23l.49-.28h2.95l.49.28s.03.02.04.03c.03.05,0,.11-.04.13l-.49.28h-2.95l-.49-.28s-.03-.02-.04-.04c-.03-.05,0-.11.04-.13",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path170",
    d: "M615.79,67.73v2.1c0,.15-.04.29-.12.41l-.61-.35v-2.89l.21-.59c.19.11.34.28.43.48.1.25.1.54.1.84",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path174",
    d: "M615.23,66.39s-.01,0-.02,0c0,0-.01,0-.02-.01,0,0-.02,0-.03,0-.24-.1-.54-.1-.84-.1h-1.47c-.3,0-.59,0-.84.1-.14.06-.27.15-.37.26,0,.01-.02.03-.03.04l.59.34h2.8l.22-.61Z",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.12,70.68h.87c.12,0,.24,0,.34-.03,0,0,.02,0,.03,0l-.06-.35h-1.52l-.29.17c.05.08.13.14.21.17.12.05.26.05.41.05",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.72,69.96v-1.33c0-.07-.02-.15-.07-.21l-.32.18v1.69l.06.34s0,0,.01,0c.12-.05.21-.14.26-.26.05-.12.05-.26.05-.41",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.47,68.42c-.04.06-.06.14-.06.21v1.33c0,.14,0,.29.05.41,0,.02.01.03.02.05,0,0,0,.01.01.02l.3-.17v-1.66l-.32-.19Z",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.72,67.03v1.1c0,.08-.02.15-.07.21l-.32-.18v-1.51l.11-.31c.1.06.18.15.22.25.05.13.05.28.05.44",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.4,67.03v1.1c0,.08.02.15.06.21l.32-.18v-1.51l-.28-.16s-.04.07-.06.11c-.05.13-.05.28-.05.44",
    fill: "#080f15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.42,66.33s0,0-.01,0c0,0,0,0-.01,0,0,0,0,0-.01,0-.13-.05-.28-.05-.44-.05h-.77c-.15,0-.31,0-.44.05-.07.03-.14.08-.19.13,0,0-.01.01-.02.02l.31.18h1.46l.12-.32Z",
    fill: "#080f15"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 77,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622,
    y: 77,
    width: 14.02,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 66,
    width: 98,
    height: 24,
    fill: "#e0e0e0"
  }))));
};
export default SvgDAhuGeneralRoomUnitEmptyState;